import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { PatientService } from '../../services/patient.service';
import { ReorderService } from '../../services/reorder.service';
import { MedscheckService } from '../../services/medscheck.service';
import { EprescriberService } from '../../services/eprescriber.service';
import { IncidentReportService } from '../../services/incident-report.service';
import { PrescriptionReviewService } from '../../services/prescription-review.service';
import { EmergencyPharmacyService } from '../../services/emergency-pharmacy.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import Swal from 'sweetalert2';

export const YMD_DATE_FORMATS = {
  parse: { dateInput: 'MM/dd/yyyy' },
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MM/dd/yyyy',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};

export class YmdNativeDateAdapter extends NativeDateAdapter {
  // Force MM/DD/YYYY in the input
  format(date: Date, displayFormat: any): string {
    if (!date) return '';
    const y = date.getFullYear();
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const d = ('0' + date.getDate()).slice(-2);
    return `${m} / ${d} / ${y}`;
  }

  parse(value: any): Date | null {
    if (typeof value === 'string' && value.length) {
      // Accept MM/DD/YYYY and "MM / DD / YYYY"
      const parts = value.split('/').map(p => (p || '').trim());
      if (parts.length === 3) {
        const m = Number(parts[0]);
        const d = Number(parts[1]);
        const y = Number(parts[2]);
        if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
          return new Date(y, m - 1, d);
        }
      }
    }
    return super.parse(value);
  }
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [
    { provide: DateAdapter, useClass: YmdNativeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: YMD_DATE_FORMATS }
  ]
})
export class PatientProfileComponent implements OnInit {

  public patientProfileImageUrl: string = 'assets/img/default-avatar.png';
  public readonly patientProfileImageFallback: string = 'assets/img/default-avatar.png';

  /** From api/Patient/GetPatientProfileImageSettings (WebApi App.config). */
  private patientProfileImageSettings: { hashInputSalt: string; fileservicePatientsBaseUrl: string } | null = null;

  @ViewChild('closeinsidentreportbutton', { static: false }) closeinsidentreportbutton;
  @ViewChild('closeReorderButton', { static: false }) closeReorderButton;
  @ViewChild('closeRemoveButtonMedsCheck', { static: false }) closeRemoveButtonMedsCheck;
  @ViewChild('closeModalEditReviewDate', { static: false }) closeModalEditReviewDate;
  @ViewChild('closeRemoveButtonIncidentReport', { static: false }) closeRemoveButtonIncidentReport;
  @ViewChild('modalOptionToReloadLastMedsCheck', { static: false }) modalOptionToReloadLastMedsCheck: ElementRef;
  @ViewChild('closeeprescriberbutton', { static: false }) closeEprescriberButton;
  @ViewChild('closeConfirmationDeleteEprescriberButton', { static: false }) closeConfirmationDeleteEprescriberButton;
  @ViewChild('closeConfirmationDeleteEmergencyPharmacyRequestButton', { static: false }) closeConfirmationDeleteEmergencyPharmacyRequestButton;

  constructor(private sharedService: SharedService,
    private reorderService: ReorderService,
    private eprescriberService: EprescriberService,
    private patientService: PatientService,
    private medscheckService: MedscheckService,
    private incidentReportService: IncidentReportService,
    private prescriptionReviewService: PrescriptionReviewService,
    private emergencyPharmacyService: EmergencyPharmacyService,
    private router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe) { }

  public patientDto: any = { addressDto: {} };
  public showLoadingMessage: boolean = true;
  public activePrescriptions: any[] = [];

  private get patientId(): number {
    return Number.parseInt(this.route.snapshot.paramMap.get('patientId'));
  }
  private get endDate(): any {
    return new Date();
  }
  private get startDate(): any {
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);
    return startDate;
  }

  //  #region Eprescriber Properties
  public eprescriberId: number = 0;
  public eprescriberVos: any[] = [];
  public eprescriberEndDate: Date;
  public eprescriberStartDate: Date;
  public showEprescriberErrorMessage: boolean;
  public eprescriberErrorMessage: any;
  public eprescriberStatusId: any = 0;
  //#endregion


  //  #region MedsCheck Properties
  public patientEmergencyPharmacyRequestId: number = 0;
  public patientEmergencyPharmacyRequestVos: any[] = [];
  public patientEmergencyPharmacyRequestStartDate: Date;
  public patientEmergencyPharmacyRequestEndDate: Date;
  //#endregion


  //  #region MedsCheck Properties
  public medsCheckVos: any[] = [];
  public medsCheckTypeVos: any[] = [];
  public medsCheckTypeId: number = 1;
  public medsCheckDefaultId: number = 0;
  public medsCheckId: number = 0;
  public medsCheckPatientAcknowledgementDate: Date;
  public medsCheckReviewDate: Date;
  public medsCheckReviewTime: any = {};
  public medsCheckErrorMessage: string;
  public showMedsCheckErrorMessage: boolean = false;
  private medsCheckVo: any = {};
  private lastSubmittedMedsCheckId: number = 0;
  private hasLastSubmittedMedsCheck: boolean = false;
  //#endregion

  // #region Reorder Properties

  public reorderVos: any[] = [];
  public reorderStartDate: Date;
  public reorderEndDate: Date;

  public reorderStatusId: any = 0;
  public reorderErrorMessage: string;
  public showReorderErrorMessage: boolean;

  //#endregion

  // #region Prescription Review Properties

  public prescriptionReviewVos: any[] = [];
  public prescriptionReviewStatusId: any = 0;
  public prescriptionReviewStartDate: Date;
  public prescriptionReviewEndDate: Date;
  public showPrescriptionReviewErrorMessage: boolean = false;
  public prescriptionReviewErrorMessage: string = "";
  public patGrpMast: string = "";

  // #endregion

  //#region Incident Report Properties
  public incidentReportVos: any[] = [];
  public showIncidentReportErrorMessage: boolean;
  public incidentReportErrorMessage: string;

  public incidentReportStartDate: Date;
  public incidentReportEndDate: Date;
  public incidentReportStatusId: any = 0;
  public incidentReportId: number;
  //#endregion

  //#region Forms Properties
  public formPhysicianOrderTypeId: number = 1;
  //#endregion

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.patientProfileImageUrl = this.patientProfileImageFallback;
    var self = this;
    setTimeout(function () {
      self.loadPatientProfileImageSettingsThenAvatar();
    }, 0);
    this.loadPatientDto();
    this.loadPatGrpMast();
  }

  private loadPatientProfileImageSettingsThenAvatar(): void {
    var self = this;
    this.patientService.getPatientProfileImageSettings().subscribe({
      next: function (cfg) {
        if (cfg && cfg.hashInputSalt && cfg.fileservicePatientsBaseUrl) {
          self.patientProfileImageSettings = cfg;
          self.updatePatientProfileImageUrl();
        }
      },
      error: function () {
        /* keep fallback */
      }
    });
  }

  /**
   * Remote avatar: {pharmacyId}_{facilityId}_{sha1hex(pharmacyId_facilityId_patientId_salt)}.jpg
   * UI keeps fallback until preload succeeds (no eager remote <img> request).
   */
  private updatePatientProfileImageUrl(): void {
    var cfg = this.patientProfileImageSettings;
    if (!cfg || !cfg.hashInputSalt || !cfg.fileservicePatientsBaseUrl) {
      return;
    }

    var pharmacyId = this.sharedService.pharmacyId;
    var facilityId = this.sharedService.facilityId;
    if (isNaN(facilityId)) {
      facilityId = 0;
    }
    var patientIdNum = this.patientId;
    var self = this;

    if (isNaN(pharmacyId) || pharmacyId <= 0 || isNaN(patientIdNum) || patientIdNum <= 0) {
      return;
    }

    if (typeof TextEncoder === 'undefined') {
      return;
    }

    var w = window;
    var cryptoRoot = w.crypto || (w as any).msCrypto;
    if (!cryptoRoot || !cryptoRoot.subtle || typeof cryptoRoot.subtle.digest !== 'function') {
      return;
    }

    var input = pharmacyId + '_' + facilityId + '_' + patientIdNum + '_' + cfg.hashInputSalt;
    var enc = new TextEncoder();
    cryptoRoot.subtle.digest('SHA-1', enc.encode(input)).then(function (digest) {
      var hash = self.arrayBufferToHexLower(digest);
      var remoteUrl = cfg.fileservicePatientsBaseUrl +
        pharmacyId + '_' + facilityId + '_' + hash + '.jpg';
      self.applyPatientProfileImageIfLoadOk(remoteUrl);
    }).catch(function () {
      /* keep fallback */
    });
  }

  /** Preload in memory; update bound URL only when the file exists and decodes. */
  private applyPatientProfileImageIfLoadOk(remoteUrl: string): void {
    var self = this;
    var probe = new Image();
    probe.onload = function () {
      self.patientProfileImageUrl = remoteUrl;
    };
    probe.onerror = function () {
      /* keep fallback */
    };
    probe.src = remoteUrl;
  }

  private arrayBufferToHexLower(buffer: ArrayBuffer): string {
    var bytes = new Uint8Array(buffer);
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
      var h = bytes[i].toString(16);
      if (h.length < 2) {
        hex += '0';
      }
      hex += h;
    }
    return hex;
  }

  public onPatientProfileImageError(): void {
    if (this.patientProfileImageUrl !== this.patientProfileImageFallback) {
      this.patientProfileImageUrl = this.patientProfileImageFallback;
    }
  }

  copyPatientIdToClipboard(): void {
    const idText = this.patientDto && this.patientDto.id != null ? String(this.patientDto.id) : '';
    if (!idText) {
      Swal.fire({
        icon: 'warning',
        title: 'No Patient ID',
        text: 'Patient ID is not available to copy.',
        timer: 1600,
        showConfirmButton: false
      });
      return;
    }
    const self = this;
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(idText).then(function () {
        Swal.fire({
          icon: 'success',
          title: 'Copied',
          text: 'Patient ID was copied to the clipboard.',
          timer: 300,
          showConfirmButton: false
        });
      }).catch(function () {
        self.copyPatientIdFallback(idText);
      });
    } else {
      this.copyPatientIdFallback(idText);
    }
  }

  private copyPatientIdFallback(idText: string): void {
    try {
      const ta = document.createElement('textarea');
      ta.value = idText;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      Swal.fire({
        icon: 'success',
        title: 'Copied',
        text: 'Patient ID was copied to the clipboard.',
        timer: 300,
        showConfirmButton: false
      });
    } catch (_e) {
      Swal.fire({
        icon: 'error',
        title: 'Copy failed',
        text: 'Could not copy Patient ID.',
        confirmButtonText: 'OK'
      });
    }
  }

  getPatientInternationalAge(): number | null {
    const raw = this.patientDto && this.patientDto.birthdate ? this.patientDto.birthdate : null;
    if (!raw) {
      return null;
    }
    const birth = new Date(raw);
    if (isNaN(birth.getTime())) {
      return null;
    }
    const today = new Date();
    const a = (today.getFullYear() * 100 + (today.getMonth() + 1)) * 100 + today.getDate();
    const b = (birth.getFullYear() * 100 + (birth.getMonth() + 1)) * 100 + birth.getDate();
    return Math.floor((a - b) / 10000);
  }

  private loadPatientDto() {
    this.showLoadingMessage = true;
    this.patientService.getPatient(this.sharedService.pharmacyId, this.patientId).subscribe(data => {
      this.patientDto = data;
      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  private validateFilterDate(dateEnd, dateStart): string[] {
    var errors: string[] = [];
    if (dateEnd < dateStart)
      errors.push("The End Date must be greater then Start Date!")
    return errors;
  }

  private metricValue(raw: any): string {
    if (raw == null) {
      return '';
    }
    return String(raw).trim();
  }

  private formatMetricNumber(value: any, fractionDigits: number): string {
    const v = this.metricValue(value);
    if (!v) {
      return '';
    }
    const m = v.match(/-?\d+(\.\d+)?/);
    if (!m || m.length === 0) {
      return '';
    }
    const n = Number(m[0]);
    if (isNaN(n)) {
      return '';
    }
    return n.toFixed(fractionDigits);
  }

  private appendUnitIfMissing(value: string, unitToken: string, fullSuffix: string): string {
    const v = value != null ? String(value).trim() : '';
    if (!v) {
      return '';
    }
    const lower = v.toLowerCase();
    if (lower.indexOf(unitToken.toLowerCase()) >= 0) {
      return v;
    }
    return v + fullSuffix;
  }

  private formatMetricWithUnit(value: any, fractionDigits: number, unitToken: string, unitSuffix: string): string {
    const num = this.formatMetricNumber(value, fractionDigits);
    if (!num) {
      return '';
    }
    return this.appendUnitIfMissing(num, unitToken, unitSuffix);
  }

  private parseMetricNumber(value: any): number | null {
    const v = this.metricValue(value);
    if (!v) {
      return null;
    }
    const m = v.match(/-?\d+(\.\d+)?/);
    if (!m || m.length === 0) {
      return null;
    }
    const n = Number(m[0]);
    return isNaN(n) ? null : n;
  }

  getMetricWeightDisplay(): string {
    return this.formatMetricWithUnit(this.patientDto && this.patientDto.weight, 1, 'kg', ' kg');
  }

  getMetricHeightDisplay(): string {
    return this.formatMetricWithUnit(this.patientDto && this.patientDto.height, 1, 'cm', ' cm');
  }

  getMetricCreatinineCrDisplay(): string {
    return this.formatMetricWithUnit(this.patientDto && this.patientDto.creatinineCr, 0, 'mol', ' \u00B5mol/L');
  }

  getMetricCreatinineCrClDisplay(): string {
    const dto = this.patientDto || {};
    return this.formatMetricWithUnit(dto.creatinineCrCl, 2, 'ml', ' mL/min');
  }

  getCreatinineDateLine(): string {
    const raw = this.patientDto && (this.patientDto.chartDate || this.patientDto.chartDateText);
    if (!raw) {
      return '';
    }
    const d = new Date(raw);
    if (isNaN(d.getTime())) {
      return '';
    }
    const y = d.getFullYear();
    const m = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    const datePart = y + '-' + m + '-' + day;

    const startChart = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const now = new Date();
    const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const dayMs = 24 * 60 * 60 * 1000;
    const days = Math.floor((startToday - startChart) / dayMs);
    const suffix = days === 0 ? '(today)' : '(' + days + ' days ago)';

    return 'Creatinine Date: ' + datePart + ' ' + suffix;
  }

  // #region Eprescriber Tab

  public loadEprescribersTab() {
    if (this.eprescriberStartDate == null || this.eprescriberEndDate == null) {
      this.eprescriberStartDate = this.getEprescriberStartDate();
      this.eprescriberEndDate = this.endDate;
    }

    if (this.eprescriberVos.length == 0) {
      this.loadEprescriberVos();
    }
  }

  private getEprescriberStartDate(): Date {
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - 90);
    return startDate;
  }

  private loadEprescriberVos() {
    this.showLoadingMessage = true;
    this.eprescriberService.getEprescribers(this.sharedService.pharmacyId, this.sharedService.facilityId, this.patientId, this.sharedService.getUserId(), this.eprescriberStatusId, this.sharedService.facilityUnitId, this.datepipe.transform(this.eprescriberStartDate, 'yyyy-MM-dd'), this.datepipe.transform(this.eprescriberEndDate, 'yyyy-MM-dd'))
      .subscribe(data => {
        this.eprescriberVos = data;
        this.showLoadingMessage = false;
      },
        err => this.showLoadingMessage = false);
  }

  public viewEprescriber(id) {
    this.setEprescriberPreviousPage();
    this.router.navigate(['eprescriber/approval/' + id]);
  }

  public editEprescriber(patientId, eprescriberId, eprescriberTypeId) {
    this.setEprescriberPreviousPage();
    this.router.navigate(['eprescriber/create/' + this.sharedService.pharmacyId + '/' + patientId + '/' + eprescriberTypeId + '/' + eprescriberId]);
  }

  public LoadEprescriberId(id) {
    this.eprescriberId = id;
  }

  public deleteEprescriber() {
    this.eprescriberService.removeEprescriber(this.eprescriberId, this.sharedService.getUserId()).subscribe(data => {
      this.sharedService.showSuccessMessage = data;
      this.closeConfirmationDeleteEprescriberButton.nativeElement.click();
      this.loadEprescriberVos();
    });
  }

  public newEprescriber(ePrescriberTypeId: number) {
    if (this.sharedService.facilityId > 0 && this.patientId > 0) {
      this.setEprescriberPreviousPage();
      this.router.navigate(['eprescriber/create/' + this.sharedService.pharmacyId + '/' + this.patientId + '/' + ePrescriberTypeId]);
    }
  }


  private setEprescriberPreviousPage() {
    localStorage.setItem('previousPage', 'profile');
  }

  public clearEprescriberErrorMessage() {
    this.showEprescriberErrorMessage = false;
    this.eprescriberErrorMessage = "";
  }

  public onActionChangeStatusEprescriber() {
    this.showEprescriberErrorMessage = false;
    var resultFieldsValidation = this.validateFilterDate(this.eprescriberEndDate, this.eprescriberStartDate);
    if (resultFieldsValidation.length == 0) {
      this.loadEprescriberVos();
      this.closeEprescriberButton.nativeElement.click();
      this.router.navigate(['profile']);
    }
    else {
      this.showEprescriberErrorMessage = true;
      this.eprescriberErrorMessage = resultFieldsValidation.join(" ");
    }
  }

  // #endregion

  // #region MedsCheck Tab

  public loadMedsCheckTab() {
    if (this.medsCheckTypeVos.length == 0) {
      this.medscheckService.getMedsCheckTypeVos().subscribe(medsCheckTypeVos => {
        this.medsCheckTypeVos = medsCheckTypeVos;
      });
    }
    if (this.medsCheckVos.length == 0) {
      this.loadMedsCheckVos();
    }
  }

  private loadMedsCheckVos() {
    this.showLoadingMessage = true;
    this.medscheckService.getMedsCheckVoIndexBy(this.sharedService.pharmacyId, this.sharedService.facilityId, this.patientId).subscribe(medsCheckVos => {
      this.medsCheckVos = medsCheckVos;
      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  public loadActivePrescriptionsTab() {
    if (this.activePrescriptions.length == 0) {
      this.showLoadingMessage = true;
      this.patientService.getPrescriptionDtos(this.sharedService.pharmacyId, this.patientId).subscribe(data => {
        this.activePrescriptions = data;
        this.showLoadingMessage = false;
      },
        err => this.showLoadingMessage = false);
    }
  }

  public loadMedscheckVo(medscheckVo) {
    this.medsCheckVo = medscheckVo;
    this.medsCheckPatientAcknowledgementDate = medscheckVo.submittedDate;
    this.medsCheckReviewDate = medscheckVo.createdDate;
    this.medsCheckReviewTime = medscheckVo.createdDate.toString().substring(11, 16);
  }

  public loadMedsCheckId(id) {
    this.medsCheckId = id;
  }

  public deleteMedsCheck() {
    this.medscheckService.deleteMedsCheck(this.medsCheckId).subscribe(resultVo => {
      if (resultVo.success) {
        this.sharedService.showSuccessMessage = resultVo.success;
        this.loadMedsCheckVos();
      } else {
        this.showMedsCheckErrorMessage = true;
        this.eprescriberErrorMessage = resultVo.message;
      }
      this.closeRemoveButtonMedsCheck.nativeElement.click();
    });
  }

  public updateMedsCheckReviewDate() {
    this.medsCheckVo.submittedDate = this.medsCheckPatientAcknowledgementDate;
    this.medsCheckVo.createdDate = this.datepipe.transform(this.medsCheckReviewDate, 'yyyy-MM-dd') + "T" + this.medsCheckReviewTime;
    this.medscheckService.updateMedsCheckReviewDate(this.medsCheckVo).subscribe(resultVo => {
      if (resultVo.success) {
        this.sharedService.showSuccessMessage = resultVo.success;
        this.loadMedsCheckVos();
        this.closeModalEditReviewDate.nativeElement.click();
      } else {
        this.showMedsCheckErrorMessage = true;
        this.eprescriberErrorMessage = resultVo.message;
      }
    });
  }

  public createMedsCheck() {
    this.patientService.getPrescriptionDtos(this.sharedService.pharmacyId, this.patientId).subscribe(data => {
      var patientProfileDto = { PatientDto: this.patientDto, PrescriptionDtos: data };

      this.patientService.createPatient(patientProfileDto).subscribe(resultVo => {
        if (resultVo.success) {
          this.medscheckService.notExistDraftMedsCheck(this.sharedService.pharmacyId, this.sharedService.facilityId, this.patientId, this.medsCheckTypeId).subscribe(resultVo => {
            if (resultVo.success) {
              this.checkNotExistMedsCheckSubmitted();
              this.showMedsCheckErrorMessage = false;
            } else {
              this.showMedsCheckErrorMessage = true;
              this.eprescriberErrorMessage = resultVo.message;
            }
          });
        } else {
          this.showMedsCheckErrorMessage = true;
          this.eprescriberErrorMessage = resultVo.message;
        }
      });
    });
  }

  public reloadLastSubmittedMedsCheck(id: number) {
    this.lastSubmittedMedsCheckId = id;
    this.hasLastSubmittedMedsCheck = true;
    this.createNewMedsCheck();
  }

  public openMedsCheckBy(medsCheckTypeId: Number, medsCheckId: Number) {
    switch (medsCheckTypeId) {
      case 1:
        this.router.navigate(['medscheck/annual/' + medsCheckId]);
        break;
      case 3:
        this.router.navigate(['medscheck/annual-home/' + this.sharedService.pharmacyId + '/' + this.patientId]);
        break;
      case 2:
        this.router.navigate(['medscheck/annual-ltc/' + this.sharedService.pharmacyId + '/' + this.patientId]);
        break;
      case 4:
        this.router.navigate(['medscheck/annual-diabetes/' + medsCheckId]);
        break;
    }
  }

  public onChangeMedsCheckPrint(medsCheckPrintTypeId, medsCheckVo) {
    var printAllFormsTypeId = "1";
    var printPharmacistsWorksheetTypeId = "2";
    var printPatientTakeHomeSummaryTypeId = "3";
    var printPersonalMedicationRecordTypeId = "4";
    var printHealthCareProviderNotificationMedsCheckServicesTypeId = "5";
    var printPatientAcknowledgementTypeId = "6";
    var printDiabetesEducationChecklistTypeId = "7";
    var printDiabeteEducationPatientTakeHomeSummaryTypeId = "8";

    switch (medsCheckPrintTypeId) {
      case printAllFormsTypeId:
        this.openMedsCheckPharmacistsWorksheet(medsCheckVo.id);
        this.openMedsCheckPersonalMedicationRecord(medsCheckVo.id);
        this.openMedsCheckHealthCareProviderNotificationMedsCheckServices(medsCheckVo.id);
        this.openMedsCheckPatientTakeHomeSummary(medsCheckVo.id);
        this.openMedsCheckPatientAcknowledgement(medsCheckVo.id, medsCheckVo.isMedsCheckDiabete);

        if (medsCheckVo.isMedsCheckDiabete) {
          this.openMedsCheckDiabetesEducationChecklist(medsCheckVo.id);
          this.openMedsCheckDiabeteEducationPatientTakeHomeSummary(medsCheckVo.id);
        }
        break;
      case printPharmacistsWorksheetTypeId:
        this.openMedsCheckPharmacistsWorksheet(medsCheckVo.id);
        break;
      case printPatientTakeHomeSummaryTypeId:
        this.openMedsCheckPatientTakeHomeSummary(medsCheckVo.id);
        break;
      case printPersonalMedicationRecordTypeId:
        this.openMedsCheckPersonalMedicationRecord(medsCheckVo.id);
        break;
      case printHealthCareProviderNotificationMedsCheckServicesTypeId:
        this.openMedsCheckHealthCareProviderNotificationMedsCheckServices(medsCheckVo.id);
        break;
      case printPatientAcknowledgementTypeId:
        this.openMedsCheckPatientAcknowledgement(medsCheckVo.id, medsCheckVo.isMedsCheckDiabete);
        break;
      case printDiabetesEducationChecklistTypeId:
        this.openMedsCheckDiabetesEducationChecklist(medsCheckVo.id);
        break;
      case printDiabeteEducationPatientTakeHomeSummaryTypeId:
        this.openMedsCheckDiabeteEducationPatientTakeHomeSummary(medsCheckVo.id);
    }
  }

  private openMedsCheckPatientTakeHomeSummary(medsCheckVoId: number) {
    window.open('report/PatientTakeHomeSummary/' + medsCheckVoId + '/' + false + '/Patient Take-Home Summary', '_blank');
  }

  private openMedsCheckDiabeteEducationPatientTakeHomeSummary(medsCheckVoId: number) {
    window.open('report/PatientTakeHomeSummary/' + medsCheckVoId + '/' + true + '/Diabetes Education Patient Take-Home Summary', '_blank');
  }

  private openMedsCheckPatientAcknowledgement(medsCheckVoId: number, isMedsCheckDiabete: boolean) {
    window.open('report/PatientAcknowledgement/' + medsCheckVoId + '/' + isMedsCheckDiabete + '/Patient Acknowledgement', '_blank');
  }

  private openMedsCheckDiabetesEducationChecklist(medsCheckVoId: number) {
    window.open('report/DiabetesEducationChecklist/' + medsCheckVoId + '/Diabetes Education Checklist', '_blank');
  }

  private openMedsCheckHealthCareProviderNotificationMedsCheckServices(medsCheckVoId: number) {
    window.open('report/HealthCareProviderNotificationMedsCheckServices/' + medsCheckVoId + '/Healthcare Provider Notification', '_blank');
  }

  private openMedsCheckPersonalMedicationRecord(medsCheckVoId: number) {
    window.open('report/PersonalMedicationRecord/' + medsCheckVoId + '/Personal Medication Record', '_blank');
  }

  private openMedsCheckPharmacistsWorksheet(medsCheckVoId: number) {
    window.open('report/PharmacistsWorksheet/' + medsCheckVoId + '/Pharmacists Worksheet', '_blank');
  }

  private checkNotExistMedsCheckSubmitted() {
    this.medscheckService.notExistMedsCheckSubmitted(this.sharedService.pharmacyId, this.sharedService.facilityId, this.patientId, this.medsCheckTypeId).subscribe(resultVo => {
      if (resultVo.success) {
        this.hasLastSubmittedMedsCheck = false;
        this.createNewMedsCheck();
      } else {
        this.getLastSubmittedMedsCheck();
      }
    });
  }

  private createNewMedsCheck() {
    this.medscheckService.createMedsCheckBy(this.sharedService.pharmacyId, this.sharedService.facilityId, this.patientId, this.sharedService.getUserId(), this.medsCheckTypeId).subscribe(medsCheckId => {
      this.medsCheckId = medsCheckId;
      if (this.hasLastSubmittedMedsCheck)
        this.updateMedsCheckByLastSubmitted();
      else
        this.openMedsCheckBy(this.medsCheckTypeId, this.medsCheckId);
    });
  }

  private updateMedsCheckByLastSubmitted() {
    this.medscheckService.updateMedsCheckByLastSubmitted(this.medsCheckId, this.lastSubmittedMedsCheckId, this.medsCheckTypeId).subscribe(resultVo => {
      if (resultVo.success) {
        this.openMedsCheckBy(this.medsCheckTypeId, this.medsCheckId);
      }
      else {
        this.showMedsCheckErrorMessage = true;
        this.medsCheckErrorMessage = resultVo.message;
      }
    });
  }

  private getLastSubmittedMedsCheck() {
    this.medscheckService.getLastSubmittedMedsCheckBy(this.sharedService.pharmacyId, this.sharedService.facilityId, this.patientId, this.medsCheckTypeId).subscribe(
      medsCheckVo => {
        this.medsCheckVo = medsCheckVo;
        this.modalOptionToReloadLastMedsCheck.nativeElement.click();
      });
  }
  // #endregion

  // #region Reorder Tab

  public loadReorderTab() {

    if (this.reorderStartDate == null || this.reorderEndDate == null) {
      this.reorderStartDate = this.startDate;
      this.reorderEndDate = this.endDate;
    }

    if (this.reorderVos.length == 0) {
      this.loadReorderVos();
    }
  }

  private loadReorderVos() {
    var dateStart = this.datepipe.transform(this.reorderStartDate, 'yyyy-MM-dd');
    var dateEnd = this.datepipe.transform(this.reorderEndDate, 'yyyy-MM-dd');
    this.showLoadingMessage = true;
    this.reorderService.loadReordersBy(this.patientId, dateStart, dateEnd, this.reorderStatusId).subscribe(data => {
      this.reorderVos = data;
      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  public clearReorderErrorMessage() {
    this.showReorderErrorMessage = false;
    this.reorderErrorMessage = "";
  }

  public onActionChangeReorderFilters() {
    var resultFieldsValidation = this.validateFilterDate(this.reorderEndDate, this.reorderStartDate);
    if (resultFieldsValidation.length == 0) {

      this.loadReorderVos()
      this.closeReorderButton.nativeElement.click();
      this.router.navigate(['profile']);
    }
    else {
      this.showReorderErrorMessage = true;
      this.reorderErrorMessage = resultFieldsValidation.join(" ");
    }
  }

  // #endregion

  // #region Prescription Review Tab

  public loadPrescriptionReviewTab() {
    if (this.prescriptionReviewStartDate == null || this.prescriptionReviewEndDate == null) {
      const now = new Date();
      // default: start = 11 months ago (1st), end = next month (1st)
      this.prescriptionReviewStartDate = new Date(now.getFullYear(), now.getMonth() - 11, 1);
      this.prescriptionReviewEndDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    }

    if (this.prescriptionReviewVos.length == 0)
      this.loadPrescriptionsReviewVos();
  }

  private loadPatGrpMast() {
    this.prescriptionReviewService.GetPatGrpMast(this.sharedService.pharmacyId, this.patientId)
      .subscribe(data => {
        this.patGrpMast = data;
      });
  }

  private loadPrescriptionsReviewVos() {
    this.showPrescriptionReviewErrorMessage = false;

    if (!this.prescriptionReviewStartDate || !this.prescriptionReviewEndDate) return;

    const start = this.datepipe.transform(this.prescriptionReviewStartDate, 'yyyy-MM-dd');
    const end = this.datepipe.transform(this.prescriptionReviewEndDate, 'yyyy-MM-dd');
    if (!start || !end) return;

    this.prescriptionReviewService.GetPrescriptionReviewIndexVosByMonthRange(
      this.sharedService.pharmacyId,
      this.sharedService.facilityId,
      start,
      end,
      this.sharedService.getUserId(),
      Number(this.prescriptionReviewStatusId),
      this.sharedService.facilityUnitId,
      this.patientId
    )
      .subscribe(data => {
        this.prescriptionReviewVos = data;
      });
  }

  public openPrescriptionReview(id: any, patientId: any) {
    this.router.navigate(['prescription-review/review/' + patientId + '/' + id]);
  }

  public onActionChangePrescriptionReviewFilters() {
    const resultFieldsValidation = (this.prescriptionReviewStartDate && this.prescriptionReviewEndDate)
      ? this.validateFilterDate(this.prescriptionReviewEndDate, this.prescriptionReviewStartDate)
      : ["Start Date and End Date are required."];

    if (resultFieldsValidation.length == 0) {
      this.loadPrescriptionsReviewVos();
    }
    else {
      this.showPrescriptionReviewErrorMessage = true;
      this.prescriptionReviewErrorMessage = resultFieldsValidation.join(" ");
    }
  }

  // #endregion

  // #region Incident Report Tab
  public loadIncidentReportTab() {
    if (this.incidentReportStartDate == null || (this.incidentReportEndDate == null)) {
      this.incidentReportStartDate = this.startDate;
      this.incidentReportEndDate = this.endDate;
    }

    if (this.incidentReportVos.length == 0)
      this.loadIncidentReportVos();
  }

  private loadIncidentReportVos() {
    this.incidentReportService.getIncidentReportsByStatusId(this.sharedService.getUserId(), this.sharedService.facilityId, this.sharedService.pharmacyId, this.incidentReportStatusId, this.sharedService.facilityUnitId, this.patientId, 0, this.datepipe.transform(this.incidentReportStartDate, 'yyyy-MM-dd'), this.datepipe.transform(this.incidentReportEndDate, 'yyyy-MM-dd'))
      .subscribe(data => {
        this.incidentReportVos = data;
      });
  }

  public reviewIncidentReport(incidentReportVo) {
    if (!incidentReportVo || !incidentReportVo.accessKey || incidentReportVo.incidentReportId == null) {
      return;
    }
    this.router.navigate(['/incident-report/review', incidentReportVo.accessKey, incidentReportVo.incidentReportId]);
  }

  public setIncidentReportId(id) {
    this.incidentReportId = id;
  }

  public clearIncidentReportErrorMessage() {
    this.showIncidentReportErrorMessage = false;
    this.incidentReportErrorMessage = "";
  }

  public onActionChangeIncidentReportFilter() {
    this.showIncidentReportErrorMessage = false;
    var resultFieldsValidation = this.validateFilterDate(this.incidentReportEndDate, this.incidentReportStartDate);
    if (resultFieldsValidation.length == 0) {

      this.loadIncidentReportVos();
      this.closeinsidentreportbutton.nativeElement.click();
      this.router.navigate(['profile']);
    }
    else {
      this.showIncidentReportErrorMessage = true;
      this.incidentReportErrorMessage = resultFieldsValidation.join(" ");
    }
  }

  removeIncidentReport() {
    this.incidentReportService.removeIncidentReport(this.incidentReportId).subscribe(data => {
      this.incidentReportErrorMessage = "Item removed";
      this.sharedService.showSuccessMessage = data;
      this.closeRemoveButtonIncidentReport.nativeElement.click();
      this.loadIncidentReportVos();
      window.scroll(0, 0);
    });
  }
  // #endregion

  // #region Forms Tab
  public openForm(formTypeId: number) {
    if (formTypeId == this.formPhysicianOrderTypeId)
      this.router.navigate([]).then(result => { window.open('report/PhysicianOrderForm/' + this.sharedService.pharmacyId + '/' + this.sharedService.facilityId + '/' + this.patientId + '/' + 'PhysicianOrderForm', '_blank'); });
  }
  // #endregion


  // #region EmergencyPharmacyRequest Tab
  openEmergencyPharmacyRequest() {
    var eprescriberTypeId = '1';
    if (this.sharedService.facilityId > 0 && this.patientId > 0) {
      this.router.navigate(['patient/emergency-pharmacy/' + this.sharedService.pharmacyId + '/' + this.patientId + '/' + eprescriberTypeId]);
    }
  }

  loadEmergencyPharmacyRequestTab() {
    if (this.patientEmergencyPharmacyRequestVos.length == 0) {
      this.loadEmergencyPharmacyRequestVos();
    }
  }

  private loadEmergencyPharmacyRequestVos() {
    this.emergencyPharmacyService.get(this.sharedService.pharmacyId, this.patientId)
      .subscribe(data => {
        this.patientEmergencyPharmacyRequestVos = data;
      });
  }

  public viewEmergencyPharmacyRequest(id) {
    this.router.navigate([]).then(result => { window.open('report/PatientEmergencyPharmacyRequest/' + id + '/' + 'PatientEmergencyPharmacyRequest', '_blank'); });
  }

  public LoadEmergencyPharmacyRequestId(id) {
    this.patientEmergencyPharmacyRequestId = id;
  }

  public deleteEmergencyPharmacyRequest() {
    this.emergencyPharmacyService.remove(this.patientEmergencyPharmacyRequestId, this.sharedService.getUserId()).subscribe(data => {
      this.sharedService.showTempSuccessMessage();
      this.closeConfirmationDeleteEmergencyPharmacyRequestButton.nativeElement.click();
      this.loadEmergencyPharmacyRequestVos();
    });
  }
  // #endregion

}
